function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.014,
    height: 20.287,
    viewBox: "0 0 24.014 20.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "side menu"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    style: {
      fill: "none",
      stroke: "#faa100",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M0 0h21.014",
    transform: "translate(1.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    transform: "translate(1.5 10.144)",
    style: {
      fill: "none",
      stroke: "#faa100",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M0 0h10.811"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    transform: "translate(1.5 18.787)",
    style: {
      fill: "none",
      stroke: "#faa100",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M0 0h2.811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.25e25f933c3523e3e9d4a15407f1ea10.svg";
export { ForwardRef as ReactComponent };